import api from 'services/api';
import { HttpCodes } from 'v2/resources/types/httpCode';
import {
  IGetUsersResponse,
  IPayloadEditUser,
  IPayloadPostNewuser,
  IPostNewUserResponse,
} from 'v2/resources/types/users';
import {
  DEFAULT_RESPONSE_GET_USERS,
  DEFAULT_RESPONSE_POST_NEW_USER,
} from './types';

export const UsersServives = {
  getUsers: async () => {
    const response = await api.get<IGetUsersResponse[]>('/users');

    if (
      response.status === HttpCodes.SUCCESS ||
      response.status === HttpCodes.SUCCESS_CREATED
    ) {
      return response.data;
    }

    return DEFAULT_RESPONSE_GET_USERS;
  },
  postNewUser: async (payload: IPayloadPostNewuser) => {
    const response = await api.post<IPostNewUserResponse>(
      '/users/employee',
      payload
    );

    if (
      response.status === HttpCodes.SUCCESS ||
      response.status === HttpCodes.SUCCESS_CREATED
    ) {
      return response.data;
    }

    return DEFAULT_RESPONSE_POST_NEW_USER;
  },
  editUser: async (payload: IPayloadEditUser, id: number) => {
    const response = await api.put(`/users/employee/${id}`, payload);

    if (
      response.status === HttpCodes.SUCCESS ||
      response.status === HttpCodes.SUCCESS_CREATED
    ) {
      return response.data;
    }

    return DEFAULT_RESPONSE_POST_NEW_USER;
  },
};
